"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFormatterEditorWidget = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var Localize_1 = require("../../../gen-src/Localize");
var Icons_1 = require("../../icons/Icons");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var TextAreaWidget_1 = require("../TextAreaWidget");
var Tooltip_1 = require("../Tooltip/Tooltip");
var TextFormatterDisplayWidget_1 = require("./TextFormatterDisplayWidget");
var TextAreaStyleName = TypeStyle.style({
    display: 'flex',
    $nest: {
        '> textarea': {
            fontFamily: 'monospace',
            height: TextFormatterDisplayWidget_1.TextFormatterHeight,
            // Safari defaults to a 2px left/right margin on textarea, which causes a jump when switching modes
            margin: 0,
            resize: 'vertical',
        },
    }
});
var MarkupDocsStyleName = TypeStyle.style({
    bottom: 0,
    display: 'inline-flex',
    fontSize: 12,
    position: 'absolute',
    right: 0,
});
var EditorStyleName = TypeStyle.style({
    position: 'relative',
});
exports.TextFormatterEditorWidget = function (props) {
    var className = props.className, disabled = props.disabled, disabledTooltipText = props.disabledTooltipText, id = props.id, label = props.label, markup = props.markup, message = props.message, onChange = props.onChange, style = props.style, testId = props.testId, valid = props.valid, restProps = tslib_1.__rest(props, ["className", "disabled", "disabledTooltipText", "id", "label", "markup", "message", "onChange", "style", "testId", "valid"]);
    // const [activeFormatters, setActiveFormatters] = React.useState<Array<FormatterType>>([]);
    // const [focusWithin, setFocusWithin] = React.useState(false);
    var textAreaId = React.useState(id || DomUtil_1.generateId())[0];
    var textAreaRef = React.useRef(null);
    var handleChange = React.useCallback(function (e) {
        if (e.target.value !== markup) {
            // setActiveFormatters(getActiveFormatters(textAreaRef.current));
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    }, [onChange, textAreaRef.current]);
    var handleKeyDown = React.useCallback(function (e) {
        // if (isCtrl(e) && ShortcutKeys.indexOf(e.keyCode) !== -1) {
        //   const formatterType: (FormatterType | undefined) = getFormatterTypeFromShortcut(e);
        //   if (formatterType) {
        //     applyMarkup(formatterType, textAreaRef.current!);
        //     e.stopPropagation();
        //     e.preventDefault();
        //   }
        // }
        var _a;
        (_a = props.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(props, e);
    }, [props.onKeyDown, textAreaRef.current]);
    var handleSelect = React.useCallback(function (e) {
        var _a;
        // setActiveFormatters(getActiveFormatters(textAreaRef.current));
        (_a = props.onSelect) === null || _a === void 0 ? void 0 : _a.call(props, e);
    }, [props.onSelect, textAreaRef.current]);
    var handleFocusBlur = React.useCallback(function (e) {
        // setFocusWithin(e.type === 'focus' || e.currentTarget.contains(findBlurRelatedTarget(e)));
    }, []);
    return (React.createElement("div", { className: EditorStyleName, "data-tb-test-id": Declarative_1.makeTestId(testId, '-TextFormatterEditorWidget'), onBlurCapture: handleFocusBlur, onFocusCapture: handleFocusBlur, style: style },
        label && React.createElement("label", { htmlFor: textAreaId }, label),
        React.createElement(TextAreaWidget_1.TextAreaWidget, tslib_1.__assign({}, restProps, { className: TypeStyle.classes(className, TextAreaStyleName), value: markup, disabled: disabled, id: textAreaId, label: null, message: message, onChange: handleChange, onKeyDown: handleKeyDown, onSelect: handleSelect, testId: testId, ref: textAreaRef, valid: valid })),
        React.createElement("span", { className: MarkupDocsStyleName }, !disabled && React.createElement(Tooltip_1.Tooltip, { getContent: FormattingHintsTable, maxWidth: -1 },
            React.createElement("span", { style: tslib_1.__assign({ display: 'inline-flex', alignItems: 'center' }, PreventUserSelect_1.PreventUserSelect) },
                React.createElement(Tooltip_1.InfoIcon, null),
                Localize_1.Messages.formattingGuide())))));
};
exports.TextFormatterEditorWidget.displayName = 'TextFormatterEditorWidget';
// the following is an interpreted-dance reimagining of FormattingHints.tsx from vizportalclient
var FormattingHeaderStyleName = TypeStyle.style({
    backgroundColor: TabStyles_1.TabStyles.Colors.F3,
    padding: 6,
    $nest: { '& ~ *': { padding: 6 } },
});
var FormattingHintsTable = function () {
    return React.createElement("div", { style: { display: 'inline-flex', whiteSpace: 'nowrap' } },
        React.createElement("div", null,
            React.createElement("div", { className: FormattingHeaderStyleName }, Localize_1.Messages.formattingHintsColumnExample()),
            React.createElement("div", null,
                React.createElement("a", { href: 'javascript:void(0)' }, Localize_1.Messages.formattingHintsLink())),
            React.createElement("div", null,
                React.createElement("strong", null, Localize_1.Messages.formattingHintsBold())),
            React.createElement("div", null,
                React.createElement("em", null, Localize_1.Messages.formattingHintsItalics())),
            React.createElement("div", null,
                React.createElement("ins", null, Localize_1.Messages.formattingHintsUnderline())),
            React.createElement("div", null,
                React.createElement("img", { src: Icons_1.encodeSvg(ImageHintSvg), style: { width: 19, height: 19, verticalAlign: 'middle' } }),
                Localize_1.Messages.formattingHintsImage())),
        React.createElement("div", null,
            React.createElement("div", { className: FormattingHeaderStyleName }, Localize_1.Messages.formattingHintsColumnMarkup()),
            React.createElement("div", null, "\"" + Localize_1.Messages.formattingHintsLink() + "\":http://www.example.com"),
            React.createElement("div", null, "*" + Localize_1.Messages.formattingHintsBold() + "*"),
            React.createElement("div", null, "_" + Localize_1.Messages.formattingHintsItalics() + "_"),
            React.createElement("div", null, "+" + Localize_1.Messages.formattingHintsUnderline() + "+"),
            React.createElement("div", null, '!http://www.example.com/image.png!')));
};
var ImageHintSvg = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 19 19'>\n  <g fill='#666'>\n    <circle cx='6' cy='5' r='1.1' />\n    <path d='M17 16c.5 0 1-.5 1-1V2c0-.5-.5-1-1-1H2c-.5 0-1 .5-1 1v13c0 .5.5 1 1 1h15zM2 15V2h15v13H2z' />\n    <path d='M1.5 14.3l5-5-.5-.8-4.5 4.3zM13.6 7.3l-4.3 4.1-.9-.5 4.5-4.2z' />\n    <path d='M9.3 11.4l-4-2 .7-.9 3.7 1.9zM17.5 9.5l-4.6-2.8-.7.8 5.3 3.2z' />\n  </g>\n</svg>";
//# sourceMappingURL=TextFormatterEditorWidget.js.map